import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective'

export const DemSbcPerspective = () => {

  const views = [
    {
      name: 'Sales by Channel',
      dims: ['PAID_PERIOD', 'CHANNEL', 'PROD'],
      kpis: ['GROSS_SALES_AMT', 'ACCR_AMT', 'NET_SALES_AMT'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['YEAR', 'QTR', 'MON']
      }
    }
  ]

  return (
    <EntityPerspective views={views} />
  )
}